// Katalog placowek publicznych dla strony /poradnie-psychologiczne/.
//
// ZASADA: to jedyne zrodlo danych teleadresowych poradni i osrodkow pomocy.
// Komponent Poradnie.jsx tylko je renderuje - nie wpisuj adresow w JSX.
//
// Dane zebrane i zweryfikowane na stronach placowek w lipcu 2026.
// Placowki zmieniaja siedziby i numery, dlatego strona zawsze pokazuje
// date aktualizacji i prosbe o telefoniczne potwierdzenie terminu.

export const AKTUALIZACJA = 'lipiec 2026';

/* ---------------------------------------------------------------- *
 * Poradnie psychologiczno-pedagogiczne - Olsztyn
 * ---------------------------------------------------------------- */
export const PPP_OLSZTYN = [
  {
    nazwa: 'Poradnia Psychologiczno-Pedagogiczna nr 1 w Olsztynie',
    opis:
      'Miejska poradnia rejonowa. Diagnoza psychologiczna, pedagogiczna i logopedyczna, opinie i orzeczenia, terapia oraz doradztwo zawodowe dla starszych uczniów.',
    adres: 'ul. Edwarda Turowskiego 3, 10-685 Olsztyn',
    tel: ['89 527 20 03', '89 527 40 17'],
    email: 'sekretariat@ppp1.olsztyn.eu',
    www: 'ppp1.olsztyn.eu',
    wwwUrl: 'https://ppp1.olsztyn.eu',
    godziny: 'pon.-pt. 7:30-16:00',
  },
  {
    nazwa: 'Poradnia Psychologiczno-Pedagogiczna nr 3 w Olsztynie',
    opis:
      'Druga miejska poradnia rejonowa, z siedzibą przy Kopernika. Pełny zakres diagnozy i terapii, zespół orzekający, wsparcie przedszkoli i szkół.',
    adres: 'ul. Mikołaja Kopernika 45, 10-512 Olsztyn',
    tel: ['89 527 23 47', '504 770 184'],
    email: 'sekretariat@ppp3.olsztyn.eu',
    www: 'ppp3.olsztyn.eu',
    wwwUrl: 'https://ppp3.olsztyn.eu',
    godziny: 'pon.-czw. 7:00-17:00, pt. 7:00-15:00',
  },
  {
    nazwa: 'Powiatowa Poradnia Psychologiczno-Pedagogiczna w Olsztynie',
    opis:
      'Siedziba w Olsztynie, rejon to gminy powiatu olsztyńskiego. Prowadzi cztery punkty konsultacyjne w terenie oraz program "Za życiem" dla najmłodszych dzieci.',
    adres: 'pl. Bema 5, 10-516 Olsztyn',
    tel: ['89 527 03 46'],
    email: 'pppp.olsztyn@poradnia-olsztyn.pl',
    www: 'poradnia-olsztyn.pl',
    wwwUrl: 'https://www.poradnia-olsztyn.pl',
    godziny: 'sekretariat pon.-pt. 7:30-13:00',
  },
];

/* ---------------------------------------------------------------- *
 * Punkty konsultacyjne w powiecie olsztynskim
 * ---------------------------------------------------------------- */
export const PUNKTY_POWIAT = [
  {
    nazwa: 'Biskupiec',
    opis: 'Największy punkt w terenie, konsultacje przez cały tydzień, także po południu.',
    adres: 'ul. Armii Krajowej 1B, 11-300 Biskupiec',
    tel: ['89 715 21 67'],
    email: 'pppp.biskupiec@poradnia-olsztyn.pl',
  },
  {
    nazwa: 'Dobre Miasto',
    opis: 'Spotkania głównie w godzinach porannych, warto umówić się z wyprzedzeniem.',
    adres: 'ul. Olsztyńska 19, 11-040 Dobre Miasto',
    tel: ['89 615 19 35'],
    email: 'pppp.dobremiasto@poradnia-olsztyn.pl',
  },
  {
    nazwa: 'Olsztynek',
    opis: 'Czynny od poniedziałku do piątku przed południem, obsługuje południe powiatu.',
    adres: 'ul. Klikowicza 4, 11-015 Olsztynek',
    tel: ['89 519 23 08'],
    email: 'pppp.olsztynek@poradnia-olsztyn.pl',
  },
  {
    nazwa: 'Barczewo',
    opis: 'Bez stałego sekretariatu na miejscu, terminy ustala siedziba przy pl. Bema 5.',
    adres: 'ul. Północna 14, 11-010 Barczewo',
    tel: ['89 514 85 25'],
    email: 'pppp.barczewo@poradnia-olsztyn.pl',
  },
];

/* ---------------------------------------------------------------- *
 * Program "Za zyciem" - wsparcie od urodzenia do szkoly
 * ---------------------------------------------------------------- */
export const ZA_ZYCIEM = [
  {
    nazwa: 'Powiatowa Poradnia Psychologiczno-Pedagogiczna w Olsztynie',
    opis:
      'Wsparcie od momentu wykrycia niepełnosprawności lub zagrożenia nią, ze szczególnym uwzględnieniem dzieci do 3. roku życia. Do 5 godzin zajęć wczesnego wspomagania rozwoju tygodniowo, konsultacje psychologa, logopedy, pedagoga i fizjoterapeuty, koordynacja dostępu do specjalistów w powiecie. Do kwalifikacji potrzebne jest orzeczenie o niepełnosprawności, opinia o potrzebie wczesnego wspomagania rozwoju albo zaświadczenie lekarskie.',
    adres: 'pl. Bema 5, 10-516 Olsztyn',
    tel: ['89 527 03 46'],
    email: 'pppp.olsztyn@poradnia-olsztyn.pl',
    www: 'poradnia-olsztyn.pl/za-zyciem',
    wwwUrl: 'https://www.poradnia-olsztyn.pl/za-zyciem/',
  },
  {
    nazwa: 'Specjalny Ośrodek Szkolno-Wychowawczy im. Kornela Makuszyńskiego w Olsztynie',
    opis:
      'Realizuje program "Za życiem" dla dzieci od urodzenia do rozpoczęcia nauki w szkole. W ofercie terapia pedagogiczna, logopedyczna i neurologopedyczna, terapia słuchowa (Tomatis, Johansen), fizjoterapia, integracja sensoryczna oraz diagnoza rozwojowa i doradztwo dla rodziców. Dokumenty przyjmowane pon.-pt. 8:00-14:00, nabór wiosenny i uzupełniający od sierpnia, do wyczerpania miejsc.',
    adres: 'al. M. J. Piłsudskiego 56A, 10-450 Olsztyn (siedziba główna: al. M. J. Piłsudskiego 42)',
    tel: ['89 533 00 86', '533 349 715'],
    email: 'sosw@sosw.olsztyn.eu',
    www: 'sosw.olsztyn.eu/za-zyciem',
    wwwUrl: 'https://sosw.olsztyn.eu/za-zyciem/',
    godziny: 'zapisy telefoniczne 10:00-14:00',
  },
];

/* ---------------------------------------------------------------- *
 * Warmia - powiaty sasiadujace
 * ---------------------------------------------------------------- */
export const PPP_WARMIA = [
  {
    nazwa: 'Poradnia Psychologiczno-Pedagogiczna w Braniewie',
    opis:
      'Rejon powiatu braniewskiego. Diagnozy psychologiczno-pedagogiczne, terapia psychologiczna, pedagogiczna i logopedyczna, badania przesiewowe, doradztwo zawodowe, szkolenia dla rad pedagogicznych.',
    adres: 'ul. Sikorskiego 15A, 14-500 Braniewo',
    tel: ['55 243 26 39'],
    email: 'sekretariat@pppbraniewo.edu.pl',
    www: 'pppbraniewo.edu.pl',
    wwwUrl: 'http://pppbraniewo.edu.pl',
    godziny: 'sekretariat pon.-pt. 7:00-15:00',
    wyroznione: true,
  },
  {
    nazwa: 'Powiatowa Poradnia Psychologiczno-Pedagogiczna w Lidzbarku Warmińskim',
    opis: 'Rejon powiatu lidzbarskiego. Psychologowie, pedagodzy i logopedzi, diagnoza, terapia, opinie i orzeczenia.',
    adres: 'ul. kard. Stefana Wyszyńskiego 20, 11-100 Lidzbark Warmiński',
    tel: ['453 030 858'],
    email: 'sekretariat@poradnia-psychologiczna.warmia.info',
    www: 'poradnia-psychologiczna.warmia.info',
    wwwUrl: 'https://www.poradnia-psychologiczna.warmia.info',
  },
  {
    nazwa: 'Poradnia Psychologiczno-Pedagogiczna w Bartoszycach',
    opis:
      'Działa w Powiatowym Centrum Rozwoju Edukacji, obsługuje przedszkola i szkoły z powiatu bartoszyckiego. Obok diagnozy i terapii prowadzi doskonalenie nauczycieli.',
    adres: 'ul. Limanowskiego 13, 11-200 Bartoszyce',
    tel: ['89 762 28 06'],
    email: 'ppp@odn-pcre.pl',
    www: 'poradniabartoszyce.eu',
    wwwUrl: 'https://poradniabartoszyce.eu',
  },
  {
    nazwa: 'Powiatowa Poradnia Psychologiczno-Pedagogiczna w Kętrzynie',
    opis:
      'Mieści się w Powiatowym Ośrodku Wspierania i Rozwoju Edukacji, rejon powiatu kętrzyńskiego wraz z gminą Reszel.',
    adres: 'ul. Pocztowa 11, 11-400 Kętrzyn',
    tel: ['89 751 35 36'],
    email: 'kontakt@powreketrzyn.pl',
    www: 'powreketrzyn.pl',
    wwwUrl: 'https://powreketrzyn.pl',
  },
];

/* ---------------------------------------------------------------- *
 * Elblag i powiat elblaski
 * ---------------------------------------------------------------- */
export const PPP_ELBLAG = [
  {
    nazwa: 'Poradnia Psychologiczno-Pedagogiczna nr 1 w Elblągu',
    opis: 'Miejska poradnia rejonowa dla części Elbląga. Diagnoza, terapia, opinie i orzeczenia dla dzieci i młodzieży.',
    adres: 'ul. Słoneczna 14, 82-300 Elbląg',
    tel: ['55 625 82 30'],
    email: 'ppp1@elblag.com.pl',
    godziny: 'sekretariat pon.-pt. 7:00-15:30',
  },
  {
    nazwa: 'Poradnia Psychologiczno-Pedagogiczna nr 2 w Elblągu',
    opis:
      'Druga poradnia miejska, ze specjalistami przyjmującymi także w soboty. Na stronie znajdziesz druki wniosków i opis rejonu działania.',
    adres: 'ul. Kosynierów Gdyńskich 30, 82-300 Elbląg',
    tel: ['55 625 82 51'],
    email: 'ppp2@elblag.eu',
    www: 'poradnia2elblag.pl',
    wwwUrl: 'https://poradnia2elblag.pl',
    godziny: 'sekretariat pon.-pt. 7:30-15:30',
  },
  {
    nazwa: 'Poradnia Psychologiczno-Pedagogiczna w Pasłęku',
    opis: 'Jednostka powiatu elbląskiego, obsługuje gminy powiatu elbląskiego. Pomoc jest dobrowolna i bezpłatna.',
    adres: 'ul. Bankowa 2, 14-400 Pasłęk',
    tel: ['55 248 24 32'],
    email: 'ppp-paslek1@wp.pl',
    www: 'ppp-paslek.pl',
    wwwUrl: 'https://www.ppp-paslek.pl',
  },
];

/* ---------------------------------------------------------------- *
 * Pozostale powiaty wojewodztwa
 * ---------------------------------------------------------------- */
export const PPP_REGION = [
  {
    nazwa: 'Szczytno',
    opis: 'Rejon powiatu szczycieńskiego.',
    adres: 'ul. Lanca 10, 12-100 Szczytno',
    tel: ['89 624 25 92', '662 143 744'],
    email: 'sekretariat@ppp.szczytno.pl',
    www: 'ppp.powiatszczycienski.pl',
    wwwUrl: 'https://ppp.powiatszczycienski.pl',
  },
  {
    nazwa: 'Mrągowo',
    opis: 'Rejon powiatu mrągowskiego.',
    adres: 'ul. Nadbrzeżna 13, 11-700 Mrągowo',
    tel: ['89 741 29 63', '89 741 00 59'],
    email: 'biuro@poradnia-mragowo.pl',
    www: 'poradnia-mragowo.pl',
    wwwUrl: 'https://poradnia-mragowo.pl',
  },
  {
    nazwa: 'Nidzica',
    opis: 'Poradnia w Powiatowym Ośrodku Rozwoju Edukacji, rejon powiatu nidzickiego.',
    adres: 'ul. Traugutta 13, 13-100 Nidzica',
    tel: ['89 625 31 39'],
    email: 'pore.poradnia@op.pl',
    www: 'poradnia.powiatnidzicki.pl',
    wwwUrl: 'https://poradnia.powiatnidzicki.pl',
  },
  {
    nazwa: 'Ostróda',
    opis: 'Część Zespołu Placówek Pedagogicznych, rejon powiatu ostródzkiego.',
    adres: 'ul. Sportowa 1, 14-100 Ostróda',
    tel: ['89 646 65 98'],
    email: 'sekretariat@poradnia.ostroda.pl',
    www: 'poradnia.ostroda.pl',
    wwwUrl: 'https://poradnia.ostroda.pl',
  },
  {
    nazwa: 'Iława',
    opis: 'Poradnia w Powiatowym Centrum Rozwoju Edukacji, rejon powiatu iławskiego.',
    adres: 'ul. Mikołaja Kopernika 8a, 14-200 Iława',
    tel: ['89 649 24 35'],
    email: 'sekretariat@pcre.ilawa.pl',
    www: 'pcre.ilawa.pl',
    wwwUrl: 'https://www.pcre.ilawa.pl',
  },
  {
    nazwa: 'Nowe Miasto Lubawskie',
    opis: 'Rejon powiatu nowomiejskiego.',
    adres: 'ul. 3 Maja 25, 13-300 Nowe Miasto Lubawskie',
    tel: ['56 472 60 38'],
  },
  {
    nazwa: 'Działdowo',
    opis: 'Rejon powiatu działdowskiego.',
    adres: 'ul. 11 Listopada 16, 13-200 Działdowo',
    tel: ['23 697 62 51'],
    www: 'poradniadzialdowo.pl',
    wwwUrl: 'http://poradniadzialdowo.pl',
  },
  {
    nazwa: 'Giżycko',
    opis: 'Rejon powiatu giżyckiego.',
    adres: 'ul. Smętka 5, 11-500 Giżycko',
    tel: ['87 428 33 15'],
    email: 'sekretariat@poregizycko.pl',
    www: 'poregizycko.pl',
    wwwUrl: 'https://www.poregizycko.pl',
  },
  {
    nazwa: 'Węgorzewo',
    opis: 'Rejon powiatu węgorzewskiego.',
    adres: 'ul. gen. J. Bema 16A, 11-600 Węgorzewo',
    tel: ['87 427 25 03'],
  },
  {
    nazwa: 'Ełk',
    opis: 'Powiatowe Centrum Pomocy Psychologiczno-Pedagogicznej, rejon powiatu ełckiego.',
    adres: 'ul. Michała Kajki 8, 19-300 Ełk',
    tel: ['87 610 27 47'],
    email: 'pcpp-p@powiat.elk.pl',
    www: 'pcpp-p.elk.pl',
    wwwUrl: 'http://pcpp-p.elk.pl',
  },
  {
    nazwa: 'Olecko',
    opis: 'Rejon powiatu oleckiego.',
    adres: 'ul. Zamkowa 2, 19-400 Olecko',
    tel: ['87 523 93 38'],
  },
  {
    nazwa: 'Gołdap',
    opis: 'Rejon powiatu gołdapskiego.',
    adres: 'ul. Wolności 11, 19-500 Gołdap',
    tel: ['87 615 16 80'],
  },
  {
    nazwa: 'Pisz',
    opis: 'Powiatowa poradnia dla rejonu piskiego.',
    adres: 'ul. Warszawska 5, 12-200 Pisz',
    tel: ['87 423 24 04'],
    www: '4p.pisz.pl',
    wwwUrl: 'http://www.4p.pisz.pl',
  },
];

/* ---------------------------------------------------------------- *
 * Pomoc spoleczna: MOPS, GOPS, CUS, PCPR
 * ---------------------------------------------------------------- */
export const POMOC_SPOLECZNA = [
  {
    grupa: 'Olsztyn i powiat olsztyński',
    placowki: [
      {
        nazwa: 'Miejski Ośrodek Pomocy Społecznej w Olsztynie',
        opis:
          'Zasiłki, dodatek mieszkaniowy i energetyczny, usługi opiekuńcze, wsparcie asystenta rodziny, pomoc w kryzysie. Tu składa się też wnioski o świadczenia dla rodzin dzieci z niepełnosprawnością.',
        adres: 'al. M. J. Piłsudskiego 61A, 10-449 Olsztyn',
        tel: ['89 534 04 14'],
        email: 'biuro@mops.olsztyn.eu',
        www: 'mopsolsztyn.pl',
        wwwUrl: 'https://mopsolsztyn.pl',
        godziny: 'pon.-pt. 7:15-15:15',
      },
      {
        nazwa: 'Powiatowe Centrum Pomocy Rodzinie w Olsztynie',
        opis:
          'Dofinansowania z PFRON (sprzęt rehabilitacyjny, likwidacja barier, turnusy), orzeczenia o niepełnosprawności, wsparcie rodzin zastępczych i poradnictwo specjalistyczne dla mieszkańców powiatu.',
        adres: 'ul. Bałtycka 65, 10-175 Olsztyn (druga siedziba: pl. Bema 5)',
        tel: ['89 544 38 00', '89 523 28 00'],
        email: 'pcpr@powiat-olsztynski.pl',
        www: 'pcpr-powiatolsztynski.pl',
        wwwUrl: 'https://pcpr-powiatolsztynski.pl',
        godziny: 'pon.-pt. 7:00-15:00, całodobowy telefon kryzysowy 665 237 899',
      },
      {
        nazwa: 'MOPS w Barczewie',
        adres: 'ul. Wojska Polskiego 15, 11-010 Barczewo',
        tel: ['89 514 97 98', '89 514 15 09'],
        email: 'mopsbarczewo@wp.pl',
        www: 'mopsbarczewo.pl',
        wwwUrl: 'https://mopsbarczewo.pl',
      },
      {
        nazwa: 'MOPS w Biskupcu',
        adres: 'ul. Niepodległości 3, 11-300 Biskupiec',
        tel: ['89 715 25 13'],
        email: 'sekretariat.mops@biskupiec.pl',
        www: 'biskupiec.pl/mops',
        wwwUrl: 'https://biskupiec.pl/mops/',
      },
      {
        nazwa: 'MOPS w Dobrym Mieście',
        opis: 'Sekretariat: 570 292 381. Pracownicy socjalni: 535 500 013 i 797 835 906.',
        adres: 'ul. Olsztyńska 3, 11-040 Dobre Miasto',
        tel: ['570 292 381'],
        email: 'sekretariat@mopsdobremiasto.pl',
      },
      {
        nazwa: 'MOPS w Olsztynku',
        adres: 'ul. Niepodległości 19, 11-015 Olsztynek',
        tel: ['89 519 26 94', '89 521 64 71'],
        email: 'sekretariat@olsztynek.naszops.pl',
        www: 'olsztynek.naszops.pl',
        wwwUrl: 'https://olsztynek.naszops.pl',
      },
      {
        nazwa: 'GOPS w Dywitach (siedziba w Tuławkach)',
        adres: 'Tuławki 10A, 11-001 Dywity',
        tel: ['89 513 22 24', '89 511 92 78'],
      },
      {
        nazwa: 'Centrum Usług Społecznych w Stawigudzie (dawny GOPS)',
        adres: 'ul. Olsztyńska 3, 11-034 Stawiguda',
        tel: ['89 512 65 03'],
        email: 'gops@stawiguda.pl',
      },
    ],
  },
  {
    grupa: 'Warmia i Elbląg',
    placowki: [
      {
        nazwa: 'MOPS w Braniewie',
        adres: 'ul. Rzemieślnicza 1, 14-500 Braniewo',
        tel: ['55 506 53 30'],
        www: 'mops.braniewo.pl',
        wwwUrl: 'https://www.mops.braniewo.pl',
        godziny: 'pon.-pt. 7:00-15:00',
      },
      {
        nazwa: 'Centrum Usług Społecznych w Lidzbarku Warmińskim (dawny MOPS)',
        adres: 'ul. Akacjowa 7, 11-100 Lidzbark Warmiński',
        tel: ['89 767 80 41'],
        email: 'cuslw@cuslw.pl',
        www: 'cuslw.pl',
        wwwUrl: 'https://cuslw.pl',
      },
      {
        nazwa: 'MOPS w Bartoszycach',
        adres: 'ul. Pieniężnego 10a, 11-200 Bartoszyce',
        tel: ['89 762 50 30'],
        email: 'sekretariat@mopsbartoszyce.pl',
        www: 'mopsbartoszyce.pl',
        wwwUrl: 'http://mopsbartoszyce.pl',
        godziny: 'pon.-pt. 7:30-15:30',
      },
      {
        nazwa: 'PCPR w Bartoszycach',
        adres: 'ul. Limanowskiego 11, 11-200 Bartoszyce',
        tel: ['89 762 97 50'],
        email: 'pcprbart@poczta.onet.pl',
      },
      {
        nazwa: 'PCPR w Kętrzynie',
        adres: 'ul. Pocztowa 9, 11-400 Kętrzyn',
        tel: ['89 751 09 00'],
        email: 'pcprketrzyn@wp.pl',
        www: 'pcprketrzyn.pl',
        wwwUrl: 'http://pcprketrzyn.pl',
        godziny: 'pon.-pt. 7:00-15:00',
      },
      {
        nazwa: 'Elbląskie Centrum Usług Społecznych (dawny MOPS w Elblągu)',
        opis: 'Miejska instytucja pomocy społecznej dla Elbląga, w tym świadczenia rodzinne i usługi wsparcia.',
        adres: 'ul. Winna 9, 82-300 Elbląg',
        tel: ['55 625 61 00'],
        email: 'ecus@ecus.pl',
        www: 'ecus.pl',
        wwwUrl: 'https://www.ecus.pl',
      },
    ],
  },
];

/* ---------------------------------------------------------------- *
 * FAQ - widoczne na stronie i w danych strukturalnych
 * ---------------------------------------------------------------- */
export const PORADNIE_FAQ = [
  {
    q: 'Czy pomoc w poradni psychologiczno-pedagogicznej jest bezpłatna?',
    a: 'Tak. Badania, konsultacje, terapia oraz wydanie opinii lub orzeczenia w publicznej poradni psychologiczno-pedagogicznej są bezpłatne. Nie jest potrzebne skierowanie od lekarza, wystarczy wniosek rodzica lub opiekuna prawnego.',
  },
  {
    q: 'Do której poradni należy moje dziecko?',
    a: 'Decyduje rejon, czyli adres przedszkola lub szkoły dziecka. Dzieci, które nie chodzą jeszcze do przedszkola, przypisane są do poradni według miejsca zamieszkania. W Olsztynie będzie to poradnia nr 1 albo nr 3, a w gminach powiatu olsztyńskiego Powiatowa Poradnia Psychologiczno-Pedagogiczna przy pl. Bema 5 lub jej punkt konsultacyjny.',
  },
  {
    q: 'Czym różni się opinia od orzeczenia?',
    a: 'Opinia opisuje potrzeby dziecka i zaleca formy wsparcia, na przykład dostosowanie wymagań albo wczesne wspomaganie rozwoju. Orzeczenie o potrzebie kształcenia specjalnego jest decyzją zespołu orzekającego i uruchamia w przedszkolu lub szkole konkretne godziny zajęć oraz dodatkowe finansowanie.',
  },
  {
    q: 'Czy diagnoza integracji sensorycznej z gabinetu prywatnego liczy się w poradni?',
    a: 'Opis diagnozy SI nie jest opinią ani orzeczeniem w rozumieniu przepisów oświatowych, ale poradnia może potraktować go jako materiał uzupełniający. Pokazuje mechanizm trudności dziecka, a nie tylko objawy, dlatego warto dołączyć go do wniosku.',
  },
  {
    q: 'Kto może skorzystać z programu "Za życiem"?',
    a: 'Dzieci z trudnościami rozwojowymi od urodzenia do rozpoczęcia nauki w szkole oraz ich rodziny. Potrzebny jest jeden z dokumentów: orzeczenie o niepełnosprawności, opinia o potrzebie wczesnego wspomagania rozwoju albo zaświadczenie lekarskie o niepełnosprawności lub jej zagrożeniu. Zajęcia są bezpłatne.',
  },
  {
    q: 'Po co mi MOPS albo PCPR, skoro dziecko chodzi na terapię?',
    a: 'Ośrodek pomocy społecznej i powiatowe centrum pomocy rodzinie prowadzą wsparcie, którego poradnia nie oferuje: świadczenia dla rodzin dzieci z niepełnosprawnością, dofinansowania z PFRON do sprzętu i turnusów rehabilitacyjnych, orzeczenia o niepełnosprawności, asystenta rodziny czy pomoc w sytuacji kryzysowej.',
  },
];
